import React, { PureComponent } from 'react';

import Modal from '../Modal/Modal.component';

import config from './NumericCustomerNumber.config';
import { separateNumber, reformatNumber, capitalizeWord } from '../utils';
import iconInfo from '../../assets/info.svg';
import iconClose from '../../assets/close.svg';

import './NumericCustomerNumber.less';

class NumericCustomerNumber extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isFocus: false,
      currentValue: '',
      prevValue: '',
      reachEnd: false,
      errorMax: false,
    };
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    if (prevState.currentValue === '' && prevProps.input.value) {
      return {
        currentValue: separateNumber(
          prevProps.input.value,
          prevProps.limit.max,
        ),
      };
    }
    return null;
  }

  _forceUpdateState = (value, fromRecent) => {
    if (fromRecent) {
      this.setState(
        {
          currentValue: separateNumber(value, this.props.limit.max),
          reachEnd: value.replace(/\D/g, '').length > this.props.limit.max,
        },
        this._onKeyDown,
      );
    } else {
      this.setState({
        currentValue: separateNumber(value, this.props.limit.max),
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.input.value !== this.props.input.value) {
      if (
        Math.abs(
          this.props.input.value.length - prevProps.input.value.length,
        ) !== 1
      ) {
        this._forceUpdateState(this.props.input.value, true);
      } else {
        this._forceUpdateState(this.props.input.value);
      }
    }
  }

  _onChange = event => {
    event.persist();
    const inputValue = event.target.value.replace(/\D/g, '');
    const caretStart = event.target.selectionStart;
    const caretEnd = event.target.selectionEnd;
    const formatedValue = separateNumber(inputValue, this.props.limit.max);

    this.setState(
      prevState => ({
        currentValue: formatedValue,
        prevValue: prevState.currentValue,
        reachEnd: inputValue.length === this.props.limit.max,
      }),
      () => {
        const { prevValue, currentValue } = this.state;

        if (caretStart === 0 && prevValue.length > currentValue.length) {
          event.target.setSelectionRange(0, 0);
        } else if (
          caretStart % 5 === 0 &&
          prevValue.length > currentValue.length
        ) {
          event.target.setSelectionRange(caretStart - 1, caretEnd - 1);
        } else if (caretStart % 5 === 0) {
          event.target.setSelectionRange(caretStart + 1, caretEnd + 1);
        } else {
          event.target.setSelectionRange(caretStart, caretEnd);
        }
        this.props.input.onChange(reformatNumber(formatedValue));
      },
    );
  };

  _onDismiss = () => {
    document.getElementById('inputCustomerNumber').blur();
    this.props.input.onChange('');
    this.setState({
      currentValue: '',
    });
  };

  _changeModalVisibility = isVisible => () => {
    this.setState({
      modal: isVisible,
    });
  };

  _onFocus = () => {
    this.setState({ isFocus: true });
  };

  _onBlur = () => {
    this.setState({ isFocus: false });
  };

  _keyDownAfterTimeout = () => {
    const { currentValue } = this.state;
    const inputValue = currentValue.replace(/\D/g, '');
    inputValue.trim(this.props.limit.max);
    this.setState({
      errorMax: false,
      currentValue: separateNumber(inputValue, this.props.limit.max),
    });
    this.props.input.onChange(reformatNumber(currentValue));
  };

  _onKeyDown = () => {
    const { reachEnd, errorMax } = this.state;
    if (reachEnd && !errorMax) {
      this.setState({ errorMax: true }, () => {
        setTimeout(this._keyDownAfterTimeout, 200);
      });
    } else if (!reachEnd && errorMax) {
      this.setState({ errorMax: false });
    }
  };

  render() {
    const {
      helper,
      input: { value },
      label,
      placeholder,
      hint,
      withHelper,
      intl: { formatMessage },
      meta: { touched, pristine, error },
      limit,
      withSeparator,
    } = this.props;

    const { errorMax, reachEnd, isFocus, currentValue } = this.state;

    const errorText = error || (errorMax ? 'validation.custNumberMax' : '');
    let errorMsg = '';
    let inputState = '';

    if (
      (!pristine && error && value.length > 3) ||
      (touched && error) ||
      (errorMax && reachEnd)
    ) {
      errorMsg = formatMessage(
        { id: errorText },
        {
          target: capitalizeWord(label),
          min: limit.min,
          max: limit.max,
        },
      );
      inputState = 'error';
    } else if (isFocus) {
      inputState = 'active';
    }

    const showHelper = typeof withHelper === 'boolean' && withHelper;
    const separatorLength =
      limit.max % 4 === 0
        ? parseInt(limit.max / 4, 10) - 1
        : parseInt(limit.max / 4, 10);
    const maxLength = limit.max + separatorLength;

    return (
      <>
        <div
          className="NumericCustomerNumber"
          style={{
            borderBottom: withSeparator ? '0.6rem solid #f5f5f5' : 'none',
          }}
        >
          <div className="input-label">
            <span id="text_labelCustomerNumber">{label}</span>
          </div>
          <div className="input-row">
            <div className={`input-box ${inputState}`}>
              <input
                id="inputCustomerNumber"
                type="text"
                inputMode="tel"
                autoComplete="off"
                pattern="[0-9]+"
                maxLength={maxLength}
                value={currentValue}
                placeholder={placeholder}
                onFocus={this._onFocus}
                onBlur={this._onBlur}
                onChange={this._onChange}
                onKeyDown={this._onKeyDown}
              />
              <button
                type="button"
                id="btn_closeCustomerNumber"
                className={`icon-status ${
                  isFocus && value.length >= 1 ? 'show' : ''
                }`}
                onMouseDown={this._onDismiss}
              >
                <img src={iconClose} alt="close" />
              </button>
            </div>

            {showHelper && (
              <div
                id="btn_infoCustomerNumber"
                className="icon-info"
                onClick={this._changeModalVisibility(true)}
              >
                <img src={iconInfo} alt="Help" />
              </div>
            )}
          </div>
          <div className="input-hint">
            <span className={`show ${inputState}`} id="text_hintCustomerNumber">
              {(inputState === 'error' && errorMsg) || hint}
            </span>
          </div>
        </div>
        {showHelper && (
          <Modal
            visible={this.state.modal}
            onClose={this._changeModalVisibility(false)}
            {...helper}
          />
        )}
      </>
    );
  }
}

NumericCustomerNumber.propTypes = config.propTypes;
NumericCustomerNumber.defaultProps = config.defaultProps;
NumericCustomerNumber.componentDetail = config.componentDetail;
NumericCustomerNumber.builderConfig = config.builderConfig;

export default NumericCustomerNumber;
